module.exports = __webpack_public_path__ + "img/1.6a9132e9.png";